import { createFileRoute } from "@tanstack/react-router";
import { useEffect } from "react";
import i18n from "@/i18n";
import { buildHead } from "@/lib/seo";
import { LegalPage } from "@/components/pages/LegalPage";
import { en } from "@/i18n/en";

export const Route = createFileRoute("/en/legal")({
  head: () =>
    buildHead({
      lang: "en",
      page: "home",
      title: en.legal.page.title + " · 2AM Hospitality",
      description: en.legal.page.intro,
    }),
  component: () => {
    useEffect(() => {
      if (i18n.language !== "en") i18n.changeLanguage("en");
    }, []);
    if (i18n.language !== "en") i18n.changeLanguage("en");
    return <LegalPage />;
  },
});
